import { statuses } from '@/returns/constants'

export const defaultOptions = {
  showLineItemOptions: true,
  showForReviewButton: true,
  showActions: true,
  statusForAccepted: statuses.accepted,
  statusForRejected: statuses.rejected,
  statusForForReview: statuses.forReview,
  acceptLabel: 'Aceptar',
  rejectLabel: 'Rechazar',
}
